// React
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Context
import { AppContext } from '../../../model/context/app/app';

// Libs
import { Button, Modal } from 'semantic-ui-react';

// Services
import SaveWorkflowService from '../../../services/SaveWorkflow.service';

// Types
type LeadCloseConfirmationModalComponentProps = {
    leadId: string | undefined;
    active: boolean;
    onClose: (v?: boolean) => void;
};

export default function LeadCloseConfirmationModalComponent(
    props: LeadCloseConfirmationModalComponentProps
): React.ReactElement {
    const [isOpen, setIsOpen] = useState(false);

    const { token } = useContext(AppContext);

    const { t } = useTranslation();

    const service = new SaveWorkflowService(props.leadId);

    function onAbort() {
        props.onClose();
    }

    function onCloseLead() {
        service.cancel(token).then((succeeded: boolean) => {
            if (succeeded) props.onClose(true);
        });
    }

    useEffect(() => {
        setIsOpen(props.active);
    }, [props.active]);

    return (
        <>
            {isOpen && (
                <Modal onClose={onAbort} open={isOpen} dimmer="blurring">
                    <Modal.Header>{t(`lead.detail.tools.tasks.CANCEL`)}</Modal.Header>
                    <Modal.Content>{t('lead.fields.question1')}</Modal.Content>
                    <Modal.Actions>
                        <Button onClick={onAbort} data-testid={'LeadCloseConfirmationModal.abort'}>
                            {t('lead.fields.abort')}
                        </Button>
                        <Button primary onClick={onCloseLead} data-testid={'LeadCloseConfirmationModal.close-lead'}>
                            {t('lead.fields.cancel')}
                        </Button>
                    </Modal.Actions>
                </Modal>
            )}
        </>
    );
}
